import React from 'react'
import { Link } from 'react-router-dom'

const BlackBtn = () => {
    return (
        <Link to='/projects' className='my-btn black-btn'>
            PORTFOLIO
        </Link>
    )
}

export default BlackBtn